import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class AtsFileUploadService {
	constructor(private http: HttpClient) {}

	uploadFile(files: FileList, url: string, headers?: any): Observable<null> {
		if ((files || []).length > 0) {
			const formData: FormData = new FormData();

			for (let i = 0; i < files.length; i++) {
				formData.append('files', files[i], files[i].name);
			}

			return this.http.put<null>(url, formData, headers ? { headers: headers } : {});
		}
		return of(null);
	}

	upload(files: FileList, url: string, headers?: any): Observable<boolean | null> {
		if ((files || []).length > 0) {
			const formData: FormData = new FormData();

			for (let i = 0; i < files.length; i++) {
				formData.append('files', files[i], files[i].name);
			}

			return this.http.put<null>(url, formData, headers ? { headers: headers } : {}).pipe(
				map(() => true),
				catchError(() => of(false))
			);
		}
		return of(null);
	}

	deleteFile(url: string): Observable<null> {
		return this.http.delete<null>(url);
	}
}
